// i18n area 'hci' — locale et-EE (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/hci.et-EE.meta.json.
import type { enUS } from './hci'

export const etEE: typeof enUS = {
  hci: {
    ceph: {
      title: 'Ceph-klaster',
      createButton: 'Loo Ceph-klaster',
      emptyTitle: 'Ühtegi hallatavat Ceph-klastrit ei ole',
      emptyBody: 'TVirt juurutab ja omab Cephi liikmessõlmedel, hüperkonvergentselt koos VM-koormusega. Loo klaster: esimene monitor ja tema manager sünnivad automaatselt valitud juhtsõlmel — seejärel kasvata seda uute monitoride ja OSD-seadmetega.',
      pageTitle: 'Ceph-klastrid',
      colState: 'Olek',
      colMembers: 'Liikmed',
      colSize: 'Suurus',
      colVersion: 'Cephi versioon',
      sizeCell: '{used} GiB kasutuses kokku {total} GiB-st',
      phase: {
        'not-deployed': 'Juurutamata',
        deploying: 'Juurutamine käib',
        healthy: 'Terve',
        degraded: 'Halvenenud',
        error: 'Viga',
        destroying: 'Hävitamine käib',
        destroyed: 'Hävitatud'
      },
      health: {
        HEALTH_OK: 'Terve (HEALTH_OK)',
        HEALTH_WARN: 'Hoiatustega (HEALTH_WARN)',
        HEALTH_ERR: 'Veaolekus (HEALTH_ERR)',
        unknown: 'Veel vaatlemata',
        observedAt: 'vaadeldud {time}'
      },
      create: {
        title: 'Loo Ceph-klaster',
        info: 'Uue Ceph-klastri loomisel tuleb valida esimene sõlm, kuhu paigaldatakse MON- ja MGR-rollid. Samuti tuleb määrata, millist alamvõrku Ceph-liikluse jaoks kasutada: public-alamvõrku kasutatakse üldise võrguliikluse jaoks, cluster-alamvõrku aga OSD-de vaheliseks sisemiseks replikatsiooniks; eri alamvõrgud ei ole tingimata vajalikud.',
        controlNode: 'Juhtsõlm',
        controlNodeHint: 'Liikmessõlm, kus sünnivad esimene MON ja MGR.',
        publicSubnet: 'Public-alamvõrk',
        publicSubnetHint: 'IPAM-is registreeritud alamvõrk — Cephi public_network. Pärast loomist muutumatu.',
        clusterSubnet: 'Cluster-alamvõrk',
        clusterSubnetHint: 'IPAM-is registreeritud alamvõrk — Cephi cluster_network (replikatsioon/backfill).',
        noSubnets: 'Ühtegi registreeritud alamvõrku ei ole — loo need enne IPAM-is',
        sameSubnet: 'Sama alamvõrk public- ja cluster-liikluse jaoks',
        sameSubnetHint: 'Märgitud = cluster-võrk (replikatsioon/backfill) langeb kokku public-võrguga. Märkimata = vali selle alamvõrk JA juhtsõlme aadress selle sees.',
        controlAddress: 'Juhtsõlme aadress',
        controlAddressHint: 'Aadress, mida IPAM teab selle sõlme kohta public-alamvõrgu sees.',
        controlClusterAddress: 'Juhtsõlme cluster-aadress',
        controlClusterAddressHint: 'Aadress, mida IPAM teab selle sõlme kohta cluster-alamvõrgu sees.',
        noAddresses: 'IPAM ei tea selle sõlme aadresse valitud alamvõrgu sees',
        started: 'Klaster loodud — bootstrap jätkub makrotaskina; faas uueneb ise',
        error: 'Klaster lükati tagasi'
      },
      detail: {
        actions: 'Saadaolevad toimingud',
        tabOverview: 'Ülevaade',
        tabManagementNodes: 'MON ja MGR',
        tabDisks: 'OSD',
        tabPools: 'Kogumid',
        tabObjects: 'Objektid',
        tabCrush: 'CRUSH-kaart',
        tabCephfs: 'CephFS',
        tabAdvanced: 'Täpsemad',
        phase: 'Faas',
        checksTitle: 'Aktiivsed tervisekontrollid',
        noChecks: 'Aktiivseid tervisekontrolle ei ole',
        checkMuted: 'summutatud',
        summaryPools: 'Kogumid',
        summaryFilesystems: 'Failisüsteemid',
        nodesCard: 'Sõlmed',
        monHint: 'Iga MON-i kõrval jookseb kolokeeritud MGR. Kolm MON-i on soovitatav kvoorum; laboriklaster alustab ühega. OSD-d ja MDS-id elavad omaenda sakkidel.',
        monHintSplit: 'MON ja MGR on sellel klastril lahutatud (Täpsemad): iga roll on sõlme kohta omaette liikmesus. Kolm MON-i on soovitatav kvoorum; vähemalt üks MGR peab olemas olema.',
        noMons: 'Ühtegi monitori ei ole deklareeritud',
        addNode: 'Lisa sõlm',
        removeNode: 'Eemalda sõlm',
        removeNodeFrom: 'Eemalda sõlm {node} (tema MON ja kolokeeritud MGR)',
        roleMon: 'MON-roll',
        roleMgr: 'MGR-roll',
        roleNa: 'N/A',
        roleNotObserved: 'veel vaatlemata',
        monInQuorum: 'kvoorumis',
        monOutQuorum: 'väljaspool kvoorumit',
        mgrActive: 'aktiivne',
        mgrStandby: 'ootel',
        addRoleMon: 'Lisa MON-roll',
        removeRoleMon: 'Eemalda MON-roll',
        addRoleMgr: 'Lisa MGR-roll',
        removeRoleMgr: 'Eemalda MGR-roll',
        restartMon: 'Taaskäivita MON-teenus',
        restartMgr: 'Taaskäivita MGR-teenus',
        addMon: 'Lisa MON',
        removeMon: 'Eemalda MON',
        removeMonFrom: 'Eemalda MON-roll sõlmelt {node}',
        addMgr: 'Lisa MGR',
        removeMgr: 'Eemalda MGR',
        removeMgrFrom: 'Eemalda MGR-roll sõlmelt {node}',
        addMds: 'Lisa MDS',
        removeMds: 'Eemalda MDS',
        removeMdsFrom: 'Eemalda MDS-roll sõlmelt {node}',
        mdsSection: 'Metaandmeserver (MDS)',
        noMds: 'Ühtegi MDS-i ei ole deklareeritud — failisüsteem nõuab enne üht',
        mdsHint: 'MDS-i liikmesus on omaette juba esimesest päevast: CephFS-ita klaster ei deklareeri ühtegi, üks aktiivne pluss üks ootel teenindavad failisüsteemi hästi. Aktiivsed ja ootel olevad valib Ceph ise deklareeritud deemonite seast.',
        mdsActiveFor: 'aktiivne — {fs}',
        mdsNotObserved: 'veel vaatlemata',
        lastMdsGuard: 'Viimast MDS-i ei saa eemaldada, kuni mõni failisüsteem on olemas — eemalda enne failisüsteemid',
        lastMonGuard: 'Viimast MON-i ei saa eemaldada — ainus väljapääs on klastri hävitamine',
        lastMgrGuard: 'Viimast MGR-i ei saa eemaldada — hallatav klaster ei jookse kunagi ilma managerita',
        registerDevice: 'Lisa OSD',
        unregisterDevice: 'Eemalda registrist',
        activeDeviceGuard: 'Aktiivne OSD — see väljub OSD elutsükli kaudu, mitte registri kaudu',
        colNode: 'Sõlm',
        devicePhase: { registered: 'Registreeritud', active: 'Aktiivne' },
        health: 'Tervis',
        state: 'Olek',
        fsid: 'fsid',
        fsidPending: 'puudub — proovi bootstrapi uuesti',
        version: 'Cephi versioon',
        publicNetwork: 'Public-võrk',
        clusterNetwork: 'Cluster-võrk',
        clusterNetworkCollapsed: '= public-võrk',
        noActions: 'Selles faasis ei ole ühtegi toimingut saadaval',
        destroyedNote: 'Klaster on hävitatud — rida eemaldatakse peagi automaatselt'
      },
      overview: {
        services: 'Teenused',
        ok: 'terved',
        warning: 'hoiatustega',
        down: 'maas',
        pgTitle: 'PG-de olekud',
        pgTotal: 'kokku {n} PG',
        capacityTitle: 'Ruum',
        ioTitle: 'Praegune I/O',
        ioReadBw: 'Lugemise ribalaius',
        ioWriteBw: 'Kirjutamise ribalaius',
        ioReadIops: 'Lugemise IOPS',
        ioWriteIops: 'Kirjutamise IOPS',
        notObserved: 'veel vaatlemata'
      },
      osd: {
        colId: 'ID',
        colClass: 'Seadmeklass',
        colState: 'Olek',
        colSize: 'Suurus',
        colPgs: 'PG',
        empty: 'Ühtegi OSD-d ei ole — lisa üks deklareeritud andmekettalt',
        markIn: 'Märgi IN',
        markOut: 'Märgi OUT',
        scrub: 'Tee scrub',
        deepScrub: 'Tee sügav scrub',
        restart: 'Taaskäivita teenus',
        details: 'Üksikasjad',
        actionGuard: 'Ainult juurutatud klastri aktiivsel OSD-l',
        inTitle: 'Märgi OSD IN',
        inBody: 'osd.{id} naaseb andmete jaotusesse (ceph osd in): Ceph tasakaalustab andmed tema peale.',
        outTitle: 'Märgi OSD OUT',
        outBody: 'osd.{id} väljub andmete jaotusest (ceph osd out): tema andmed tasakaalustatakse mujale ja liiasus on VÄHENDATUD seni, kuni backfill jookseb. Igal hetkel tagasi pööratav toiminguga Märgi IN.',
        scrubTitle: 'Planeeri scrub',
        scrubBody: 'Planeeritakse osd.{id} scrub: MON paneb selle järjekorda ja järgnevate sweepide PG-olekud jutustavad tulemuse.',
        deepScrubTitle: 'Planeeri sügav scrub',
        deepScrubBody: 'Planeeritakse osd.{id} sügav scrub: variant, mis kontrollib baite — I/O-le raskem, sama mehaanika.',
        restartTitle: 'Taaskäivita OSD-teenus',
        restartBody: 'osd.{id} peatatakse ja käivitatakse uuesti tema sõlme workeri järelevalve kaudu.',
        started: 'Toiming käivitatud — vaatlus uueneb ise',
        error: 'OSD toiming lükati tagasi'
      },
      osdDetail: {
        title: 'OSD üksikasjad',
        tabGeneral: 'Üldine',
        tabNetwork: 'Võrk',
        tabDevices: 'Seadmed',
        version: 'Versioon',
        hostname: 'Hostinimi',
        dataPath: 'OSD andmete tee',
        objectStore: 'OSD object store',
        encrypted: 'Krüpteeritud',
        yes: 'Jah',
        no: 'Ei',
        memory: 'Mälukasutus (PSS)',
        pid: 'Protsessi ID (PID)',
        front: 'Front-aadress (klient ja monitor)',
        hbFront: 'Front-heartbeat-aadress',
        back: 'Back-aadress (OSD)',
        hbBack: 'Back-heartbeat-aadress',
        colDevice: 'Seade',
        colType: 'Tüüp',
        colPhysical: 'Füüsiline seade',
        colSize: 'Suurus',
        volumeTitle: 'Köite üksikasjad',
        creationTime: 'Loomise aeg',
        lvName: 'LV Name',
        lvPath: 'LV Path',
        lvUuid: 'LV UUID',
        vgName: 'VG Name',
        noDevices: 'Selle OSD kohta ei ole ühtegi seadet vaadeldud'
      },
      restart: {
        title: 'Taaskäivita teenus',
        monBody: 'MON-deemon sõlmel {node} peatatakse ja käivitatakse uuesti workeri järelevalve kaudu.',
        mgrBody: 'MGR-deemon sõlmel {node} peatatakse ja käivitatakse uuesti workeri järelevalve kaudu.',
        started: 'Taaskäivitus algatatud — vaatlus uueneb ise',
        error: 'Taaskäivitus lükati tagasi'
      },
      encryptionMode: {
        alwaysOn: 'Alati sisse lülitatud (dmcrypt)',
        alwaysOff: 'Alati välja lülitatud',
        perOsd: 'Valik iga OSD kohta',
        section: 'OSD-de krüpteerimine puhkeolekus',
        title: 'Muuda OSD-de krüpteerimisrežiimi',
        hint: 'Kuidas valmistatakse ette UUED OSD-d. Olemasolevad OSD-d hoiavad oma kettapõhist olekut: selle muutmiseks eemaldatakse OSD ja luuakse uuesti.',
        body: 'Režiimiks saab "{mode}" ja see kehtib AINULT UUTE OSD-de kohta: iga olemasolev OSD hoiab oma praegust krüpteerimisolekut.',
        apply: 'Muuda režiimi',
        error: 'Režiimi muutmine lükati tagasi'
      },
      pin: {
        address: 'Public-aadress (valikuline pin)',
        clusterAddress: 'Cluster-aadress (valikuline pin)',
        autoPlaceholder: 'automaatne alamvõrgus {cidr}',
        hint: 'Deemonipõhine aadressistamine: tühi = Ceph haagib end ise deklareeritud võrgu sisse; täidetud = see eksemplar pinnitakse oma conf-sektsioonis sellele aadressile.'
      },
      addMon: {
        title: 'Lisa sõlm',
        node: 'Sõlm',
        address: 'Public-aadress',
        addressHint: 'Sõlme aadressid, mida IPAM teab public-alamvõrgu sees — automaatne, kui mõni olemasolev deklaratsioon katab sõlme.',
        clusterAddress: 'Cluster-aadress',
        clusterAddressHint: 'Kohustuslik: cluster-alamvõrk on eraldi ja sõlme ei ole seal veel deklareeritud.',
        noAddresses: 'IPAM ei tea selle sõlme aadresse alamvõrgu sees',
        error: 'MON-i lisamine lükati tagasi'
      },
      removeMon: {
        title: 'Eemalda MON',
        body: 'MON ja tema kolokeeritud MGR lahkuvad sõlmelt {node}. Juurutatud klastris deemonid peatatakse ja eemaldatakse kvoorumist.',
        error: 'MON-i eemaldamine lükati tagasi'
      },
      addMgr: {
        title: 'Lisa MGR',
        node: 'Sõlm',
        hint: 'Täpsemad (lahutatud MON ja MGR): eraldiseisev manager sünnib valitud liikmessõlmel sõlmeafiinse taskiga. Cephi active/standby valimine valib aktiivse MGR-i ise.',
        error: 'MGR-i lisamine lükati tagasi'
      },
      removeMgr: {
        title: 'Eemalda MGR',
        body: 'Eraldiseisev MGR lahkub sõlmelt {node}. Juurutatud klastris deemon peatatakse ja tema olek eemaldatakse; sõlme MON-i (kui see on olemas) ei puudutata.',
        error: 'MGR-i eemaldamine lükati tagasi'
      },
      addMds: {
        title: 'Lisa MDS',
        node: 'Sõlm',
        hint: 'CephFS-i metaandmeserver: sünnib valitud liikmessõlmel sõlmeafiinse taskiga, workeri järelevalve all nagu MON ja MGR. Aktiivsed ja ootel olevad valib Ceph ise — üks aktiivne pluss üks ootel teenindavad failisüsteemi hästi.',
        error: 'MDS-i lisamine lükati tagasi'
      },
      removeMds: {
        title: 'Eemalda MDS',
        body: 'MDS lahkub sõlmelt {node}. Juurutatud klastris deemon peatatakse ja tema olek eemaldatakse; API lükkab viimase MDS-i tagasi seni, kuni mõni failisüsteem seda vajab.',
        error: 'MDS-i eemaldamine lükati tagasi'
      },
      split: {
        title: 'Lahutatud MON ja MGR',
        label: 'Luba MON ja MGR eri sõlmedel',
        hint: 'Väljas (vaikimisi) = ratifitseeritud standard: iga MON-i kõrval jookseb kolokeeritud MGR, üksainus liikmesus. Sees = MGR-ide liikmesus muutub omaette liikmesuseks, mida hallatakse toimingutega Lisa/Eemalda MGR halduse sõlmede sakil.',
        enable: 'Aktiveeri',
        disable: 'Deaktiveeri',
        enableBody: 'MGR-ide liikmesus muutub MON-idest sõltumatuks ja lähtestatakse praegusest kolokatsioonist. Toimingud Lisa/Eemalda MGR aktiveeruvad halduse sõlmede sakil. See lõdvendab platvormi vaikeseadet — hoia see sees ainult siis, kui tead, milleks seda vajad.',
        disableBody: 'Tagasi standardse kolokatsiooni juurde: üks MGR iga MON-i juures, üksainus liikmesus. Lubatud ainult siis, kui MGR-ide liikmesus juba langeb kokku MON-idega — joonda see enne toimingutega Lisa/Eemalda MGR, muidu API lükkab tagasi.',
        error: 'Muudatus lükati tagasi'
      },
      rawEditor: {
        title: 'Toores CRUSH-redaktor',
        label: 'Näita CRUSH-sakil toorest crushmapi redaktorit',
        hint: "Väljas (vaikimisi) = juhitud reeglipind on standardne tööriist. Sees = CRUSH-sakk näitab ka dekompileeritud crushmapi muudetava tekstina. Salvestamine nõuab alati sudot ja kinnituseks klastri nime ning läbib crushtooli compile'i ja testi ENNE klastrisse jõudmist."
      },
      osdFlags: {
        section: 'Globaalsed OSD-lipud',
        title: 'OSD-lippude käsitsi alistamine',
        notObserved: 'veel vaatlemata',
        standardFlowsHint: 'Platvormi standardvood haldavad neid lippe tavaolukordades ise (sõlme hooldus seab sihitud nooudi, ketta vahetus käib OSD elutsükli kaudu). See jaotis on käsitsi alistamine operaatorile, kes teab, mida ta teeb.',
        notDeployedGuard: 'OSD-lipud eksisteerivad ainult juurutatud klastris',
        set: 'Sea lipp',
        unset: 'Eemalda lipp',
        setBody: 'Globaalne lipp {flag} SEATAKSE osdmapil. See püsib seni, kuni see selgesõnaliselt eemaldatakse — unustatud lipp halvendab klastri iseparanemist.',
        unsetBody: 'Globaalne lipp {flag} EEMALDATAKSE osdmapilt.',
        error: 'Lipu muutmine lükati tagasi',
        flag: {
          noout: 'Ühtegi OSD-d ei märgita andmete jaotusest välja — deemoni kaotusel tasakaalustamist ei toimu',
          norebalance: 'Andmete tasakaalustamine on peatatud',
          nobackfill: 'Backfill on peatatud',
          norecover: 'Recovery on peatatud',
          pause: 'KOGU klientide I/O on pausil (lugemised ja kirjutamised)',
          noin: 'Käivituvaid OSD-sid ei märgita automaatselt sisse',
          nodown: 'Kättesaamatuid OSD-sid ei märgita maas olevaks — varjab tegelikke rikkeid'
        }
      },
      pools: {
        section: 'Kogumid',
        create: 'Loo kogum',
        createGuard: 'Kogumid eksisteerivad ainult juurutatud klastris',
        notObserved: 'Kogumite vaatlust ei ole — MON-i sweep raporteerib siia',
        empty: 'Klastris ei ole ühtegi kogumit',
        colName: 'Nimi',
        colReplication: 'Size / min size',
        colPgNum: 'PG',
        colApplication: 'Rakendus',
        colRule: 'CRUSH-reegel',
        colUsage: 'Kasutus',
        observedAtLabel: 'Vaadeldud',
        objects: '{n} objekti',
        inUseBy: 'kasutuses: {name}',
        internalGuard: 'Cephi sisemine kogum — platvorm ei kustuta seda kunagi',
        delete: 'Kustuta kogum',
        deleteGuard: 'Tarbib storage {name} — kustuta enne storage',
        hint: 'Ainult replikeeritud kogumid (erasure coding jääb v1 skoobist välja). Replikatsioon elab Cephis: see tabel on MON-i sweepi vaadeldud tõde.',
        createTitle: 'Loo kogum',
        createHint: 'Kogum sünnib klastris nõutud replikatsiooniga ja lubatud rbd-rakendusega — töö teeb task MON-sõlmel. Lülita sisse "Paku storage\'iks", et seda kohe sama liigutusega tarbida.',
        name: 'Kogumi nimi',
        nameHint: 'DNS-turvaline (väiketähed, numbrid, sidekriipsud).',
        size: 'Replikad (size)',
        sizeHint: 'Iga objekti koopiate arv. Vaikimisi 3.',
        minSize: 'Minimaalsed replikad (min_size)',
        minSizeHint: 'Minimaalne koopiate arv I/O teenindamiseks — järgib väärtust size − 1, kuni sa seda muudad.',
        createError: 'Kogumi loomine lükati tagasi',
        deleteTitle: 'Kustuta kogum',
        deleteBody: 'Kogum {pool} ja IGA objekt selle sees hävitatakse pöördumatult. Kinnitamiseks trüki kogumi nimi.',
        confirmLabel: 'Kogumi nimi',
        confirmHint: 'Kinnitamiseks trüki kogumi nimi',
        deleteError: 'Kogumi kustutamine lükati tagasi',
        detailTitle: 'Kogumi üksikasjad',
        autoscaler: 'PG autoscaler',
        autoscalerOn: 'Aktiivne',
        autoscalerOff: 'Pole aktiivne',
        autoscalerWarn: 'Teavitus',
        pgNumLabel: 'PG-de arv',
        pgNumCaption: 'Vaadeldud: autoscaler võib seda iseseisvalt muuta — see väli kirjutab soovi.',
        storage: 'Seotud TVirti storage',
        addAsStorage: "Lisa TVirti storage'ina",
        ruleSudoHint: 'CRUSH-reegli muutmine nõuab operaatori parooli.',
        updateError: 'Kogumi muutmine lükati tagasi',
        updated: 'Kogumi muutmine algatatud — vaatlus uueneb ise'
      },
      crush: {
        section: 'CRUSH-reeglid',
        notObserved: 'CRUSH-i vaatlust veel ei ole — MON-i sweep raporteerib siia',
        empty: 'Klastris ei ole vaadeldud ühtegi reeglit',
        hint: 'Reegel otsustab, KUHU iga objekti koopiad satuvad — tema rikkedomeen on üksus, mis võib rikki minna ilma andmeid kaotamata. Kogumid osutavad reeglile; sisseehitatud replicated_rule (üks koopia serveri kohta) on sünnijärgne vaikevalik.',
        create: 'Loo reegel',
        createGuard: 'CRUSH-reeglid eksisteerivad ainult juurutatud klastris',
        createTitle: 'Loo CRUSH-reegel',
        createHint: 'Reegel = üks rikkedomeeni valik. Reegel sünnib replikeerituna vaikimisi rootil — töö teeb task MON-sõlmel; seo kogumid pärast Kogumite sakilt.',
        createError: 'Reegli loomine lükati tagasi',
        name: 'Reegli nimi',
        nameHint: 'DNS-turvaline (väiketähed, numbrid, sidekriipsud).',
        domain: 'Rikkedomeen',
        domainChoice: {
          osd: 'Iga koopia eri OSD-l',
          host: 'Iga koopia eri serveril',
          rack: 'Iga koopia eri rackis'
        },
        domainCustom: 'Kohandatud (käsitsi kirjutatud sammud)',
        domainOther: 'Iga koopia eri üksuses {type}',
        rackGuardHint: 'Vaadeldud hierarhias ei ole ühtegi rack-bucketit: reegli saab siiski luua, kuid ükski kogum ei saa sellele osutada enne, kui mõni rack on deklareeritud liikmesserverite paiknemises (sõlme seaded) — ümberjoondamise task ehitab bucketi ja seostamine avaneb ise.',
        treeTitle: 'Vaadeldud hierarhia',
        treeNotObserved: 'Hierarhia vaatlust ei ole — MON-i sweep raporteerib siia',
        treeOsds: '{n} OSD',
        treeHint: 'CRUSH-kaart nii, nagu klaster seda näeb: root → deklareeritud tasemed → server (host) → OSD. Topoloogia järgib iga serveri deklareeritud paiknemist (sõlme seaded) — paiknemise muutus joondab selle taskiga ümber.',
        unplacedWarning: 'Deklareeritud paiknemiseta liikmed: {nodes} — nende hostid jäävad otse rooti alla, väljapoole deklareeritud topoloogiat. Deklareeri paiknemine sõlme seadetes (hoiatus, mitte kunagi blokeering).',
        colName: 'Nimi',
        colDomain: 'Rikkedomeen',
        colPools: 'Kogumid',
        builtinChip: 'sisseehitatud',
        builtinGuard: 'Klastri vaikereegel — platvorm ei kustuta seda kunagi',
        detailAction: 'Reegli üksikasjad',
        detailType: 'Tüüp',
        backToRules: 'Reeglid',
        ruleNotObserved: 'Vaadeldud reeglite loend ei nimeta seda reeglit',
        noPools: 'Ükski kogum ei sõida sellel reeglil',
        delete: 'Kustuta reegel',
        deleteTitle: 'Kustuta CRUSH-reegel',
        deleteBody: 'Reegel {rule} eemaldatakse klastri crushmapist. Ükski kogum ei tohi sellel sõita. Kinnitamiseks trüki reegli nimi.',
        deleteGuard: 'Sellel sõidab kogum {name} — suuna kogum enne mujale',
        confirmLabel: 'Reegli nimi',
        confirmHint: 'Kinnitamiseks trüki reegli nimi',
        deleteError: 'Reegli kustutamine lükati tagasi',
        changeRule: 'Muuda CRUSH-reeglit',
        changeRuleTitle: 'Muuda CRUSH-reeglit',
        changeRuleHint: 'Kogum hakkab oma objekte paigutama valitud reegli järgi — Ceph liigutab olemasolevad andmed sellega vastavusse (täis kogumi puhul järgneb tasakaalustamine).',
        changeRuleError: 'Reegli muutmine lükati tagasi',
        rule: 'CRUSH-reegel',
        rawTitle: 'Toores crushmap (dekompileeritud)',
        rawWarning: 'OHT: see tekst on klastri KOGU paigutuspoliitika. Vale kaart võib katki teha kõigi kogumite paigutuse korraga. Salvestamine kompileerib ja katsetab kaardi crushtooliga ENNE selle süstimist — kuid ka kehtiv kaart võib olla halb mõte.',
        rawReload: 'Laadi uuesti',
        rawLoading: 'Päring lennus — ainult lugev task dekompileerib crushmapi…',
        rawSave: 'Salvesta crushmap',
        rawSaveTitle: 'Süsti crushmap',
        rawSaveBody: "Muudetud tekst asendab pärast crushtooli compile'i ja testi KOGU klastri crushmapi. Kinnitamiseks trüki klastri nimi.",
        rawConfirmLabel: 'Klastri nimi',
        rawConfirmHint: 'Kinnitamiseks trüki {name}',
        rawError: 'Crushmapi toiming ebaõnnestus',
        rawHint: 'Tekst on crushtool -d vorm. Kompileerimis- ja testivead tulevad crushtoolilt sõna-sõnalt tagasi — kaart ei jõua klastrisse, kui üks kahest väravast ebaõnnestub.'
      },
      objects: {
        poolsSection: 'Objektide uurija',
        poolsHint: 'Vali kogum, et loetleda selle RBD-tõmmiseid. Iga sügav lugemine jookseb ainult lugeva taskina MON-sõlmel — see ei blokeeri päris operatsioone ega ole nende poolt blokeeritud.',
        deployedGuard: 'Objektipäringud vastavad ainult juurutatud klastris',
        browse: 'Sirvi objekte',
        detailAction: 'Tõmmise üksikasjad',
        backToPools: 'Kogumid',
        backToImages: 'Tõmmised',
        refresh: 'Värskenda',
        loading: 'Päring lennus — ainult lugev task pärib klastrilt…',
        error: 'Päring ebaõnnestus',
        retry: 'Proovi uuesti',
        notRbd: 'Kogum rakendusega "{app}" — see ei sisalda RBD-tõmmiseid, siin ei ole midagi uurida',
        noImages: 'Selles kogumis ei ole ühtegi RBD-tõmmist',
        colImage: 'Tõmmis',
        colSize: 'Suurus',
        colObjects: 'Objektid',
        colSnapshots: "Snapshot'id",
        imagesHint: "Tarbival rbd-storage'il olevad kettad on tõmmised, mille nimi on nende ketta ID. Objektide arv on eraldatu (suurus / objekti suurus) — tegelik kasutus elab tõmmise üksikasjades.",
        infoTitle: 'Tõmmis',
        infoSize: 'Virtuaalne suurus',
        infoObjects: 'Objektid (eraldatud)',
        infoObjectSize: 'Objekti suurus',
        infoPrefix: 'Objektide prefiks',
        infoFormat: 'Vorming',
        infoFeatures: 'Omadused',
        usageTitle: 'Tegelik kasutus (rbd du)',
        usageOf: 'eraldatud {provisioned} GiB-st',
        usageHint: 'Olemuselt thin: baite hõivavad ainult kirjutatud objektid.',
        watchersTitle: 'Watcherid',
        noWatchers: 'Ühtegi watcherit ei ole — praegu ei hoia keegi seda tõmmist avatuna',
        snapshotsTitle: "RBD snapshot'id",
        noSnapshots: "Sellel tõmmisel ei ole ühtegi RBD-snapshot'i",
        colSnapshot: 'Snapshot',
        colProtected: 'Kaitstud',
        colTimestamp: 'Loodud',
        protected: 'kaitstud',
        mappingTitle: 'Füüsiline vastendus (OSD-de hulk)',
        mappingSampled: 'Valim: {sampled} objekti {total}-st — aus kokkuvõte: suurte tõmmiste puhul koondub hulk KÕIGIKS kogumi OSD-deks (CRUSH jaotab objektid üle kogu kogumi).',
        mappingComplete: 'Kõik objektid vastendatud ({total} / {total}).',
        objectQueryTitle: 'Vastenda üksik objekt',
        objectName: 'Objekti nimi',
        objectHint: 'RADOS-e objektinimed on <prefiks>.<16-kohaline hex-indeks> — ceph osd map vastab PG ja OSD-kolmikutega.',
        mapObject: 'Vastenda',
        primary: 'primaarne: osd.{osd}'
      },
      registerDevice: {
        title: 'Registreeri OSD-seade',
        hint: "Elavas klastris registreerimine ka VALMISTAB seadme ette: sellest saab BlueStore'i OSD automaatse sõlmeafiinse taskiga (mitte kunagi tühi, ratifitseeritud 2026-07-24). Seade kuulub kogu pargis kõige rohkem ühte Ceph-klastrisse.",
        disk: 'Andmeketas',
        diskHint: 'Sõlme deklareeritud andmekettad — nimi ja seerianumber',
        noDeclared: 'Sellel sõlmel ei ole ühtegi deklareeritud andmeketast — märgista need enne sõlme kohalikes seadetes',
        serialHint: 'Seadme seerianumber — identiteedi pin',
        encrypted: 'Krüpteeri see OSD (dmcrypt)',
        encryptedHint: 'OSD-põhine valik (klastri režiim on "valik iga OSD kohta"): see külmub sellel kettal registreerimise hetkel — hilisem režiimi muutus ei kirjuta seda kunagi üle; seda teeb rea toiming krüpteeri/dekrüpteeri.',
        error: 'Registreerimine lükati tagasi'
      },
      unregisterDevice: {
        title: 'Eemalda seade registrist',
        body: 'Ainult register: {name} lakkab olemast selle klastri OSD-kandidaat. Tema baite ei puudutata.',
        error: 'Registrist eemaldamine lükati tagasi'
      },
      deploy: {
        action: 'Proovi juurutamist uuesti',
        title: 'Proovi bootstrapi uuesti',
        body: "Sünni-bootstrap alustab praegusest seadistusest otsast peale: monid käivituvad, iga registreeritud seade valmistatakse ette ja aktiveeritakse BlueStore'i OSD-na. Toiming jookseb makrotaskina — faas uueneb ise.",
        started: 'Bootstrap algatatud — jätkub makrotaskina; faas uueneb ise',
        error: 'Bootstrap lükati tagasi'
      },
      propose: {
        action: "Paku storage'iks",
        title: "Paku storage'iks",
        hintPool: "Olemasolevast kogumist {name} saab TVirti storage: kogumiga piiratud cephx-identiteet jõuab keystore'i ja ceph-rbd storage sünnib valmis kujul. Pakkumine tarbib kogumi — ei loo neid kunagi.",
        hintFs: "Olemasolevast failisüsteemist {name} saab TVirti storage: failisüsteemiga piiratud cephx-identiteet jõuab keystore'i ja cephfs-storage sünnib valmis ja haagitud kujul. Pakkumine tarbib failisüsteemi — ei loo neid kunagi.",
        name: "Storage'i nimi",
        nameHint: "DNS-1123, scope'is unikaalne — cephx-identiteet võtab nime tema järgi.",
        path: 'Tee failisüsteemi sees',
        pathHint: 'Absoluutne tee failisüsteemi sees, mille storage haagib — kahtluse korral /.',
        alsoPropose: "Paku kohe storage'iks",
        alsoProposePoolHint: "Pärast loomist pakub sama liigutus vastsündinud kogumit ceph-rbd storage'iks — kaks selgesõnalist kutset, üksainus dialoog.",
        alsoProposeFsHint: "Pärast loomist pakub sama liigutus vastsündinud failisüsteemi cephfs-storage'iks — kaks selgesõnalist kutset, üksainus dialoog.",
        guard: "Paku storage'iks — ainult tervel klastril",
        started: 'Pakkumine vastu võetud — storage materialiseerub; leiad selle Storage alt',
        submit: 'Loo storage',
        error: 'Pakkumine lükati tagasi'
      },
      fs: {
        section: 'Failisüsteemid',
        create: 'Loo failisüsteem',
        createGuard: 'Failisüsteemid eksisteerivad ainult juurutatud klastris',
        mdsFirstGuard: 'Lisa enne MDS — metaandmeserverita failisüsteem sünnib kasutuskõlbmatuna',
        notObserved: 'Failisüsteemide vaatlust ei ole — MON-i sweep raporteerib siia',
        empty: 'Klastris ei ole ühtegi failisüsteemi',
        colName: 'Nimi',
        colPools: 'Kogumid',
        colMds: 'MDS',
        noActiveMds: 'ühtegi aktiivset MDS-i ei ole',
        delete: 'Eemalda failisüsteem',
        deleteGuard: 'Tarbib storage {name} — kustuta enne storage',
        hint: 'Failisüsteem omab oma andme- ja metaandmekogumeid (cephfs.<nimi>.data / .meta): need sünnivad koos temaga ja surevad koos temaga — removeFs, mitte kunagi kogumi käsitsi kustutamine. See tabel on MON-i sweepi vaadeldud tõde.',
        createTitle: 'Loo failisüsteem',
        createHint: 'Failisüsteem sünnib klastris koos oma kahe kogumiga (rakendus cephfs) ja seda teenindavad deklareeritud MDS-id — töö teeb task MON-sõlmel. Lülita sisse "Paku storage\'iks", et seda kohe sama liigutusega tarbida.',
        name: 'Failisüsteemi nimi',
        nameHint: 'DNS-turvaline (väiketähed, numbrid, sidekriipsud).',
        sizeHint: 'MÕLEMA sündiva kogumi replikad. Vaikimisi 3.',
        createError: 'Failisüsteemi loomine lükati tagasi',
        deleteTitle: 'Eemalda failisüsteem',
        deleteBody: 'Failisüsteem {fs} ja IGA fail selle sees hävitatakse pöördumatult — tema andme- ja metaandmekogumid surevad koos temaga. Kinnitamiseks trüki failisüsteemi nimi.',
        confirmLabel: 'Failisüsteemi nimi',
        confirmHint: 'Kinnitamiseks trüki failisüsteemi nimi',
        deleteError: 'Failisüsteemi eemaldamine lükati tagasi'
      },
      destroy: {
        action: 'Hävita',
        retryAction: 'Proovi kustutamist uuesti',
        retryGuard: 'Hävitamine käib — kordus kehtib ebaõnnestunud hävitamise kohta (muidu lükkab lease tagasi)',
        title: 'Hävita klaster',
        body: "Juurutatud fabric lammutatakse: iga selle klastri deemon peatub ning tema süsteemiolek ja keystore'i võtmed vabastatakse. Õnnestunud hävitamise järel eemaldatakse klaster automaatselt.",
        confirmLabel: 'Klastri nimi',
        confirmHint: 'Kinnitamiseks trüki klastri nimi',
        wipe: 'Kustuta registreeritud seadmed',
        wipeHint: 'Märgitud: iga registreeritud seadme allkirjad kustutatakse — nende peal olevad andmed hävitatakse. Märkimata: baidid jäävad puutumata ja seadmed jäävad registreerituks.',
        guard: 'Hävita — midagi ei ole juurutatud',
        started: 'Hävitamine algatatud — jätkub makrotaskina; faas uueneb ise',
        error: 'Hävitamine lükati tagasi'
      },
      delete: {
        guard: 'Kustuta — ainult juurutamata seadistus (hävita enne)',
        title: 'Kas kustutada {name}?',
        body: 'Seadistus ja tema seadmeregister eemaldatakse. Lubatud ainult seni, kuni midagi ei ole juurutatud.',
        error: 'Kustutamine lükati tagasi'
      }
    }
  }
}
